import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Layout from '@/layout'
import DefaultView from '../views/DefaultView.vue'

const routes = [
  {
    path: '/',
    name: 'order',
    redirect: '/order/index'
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const asyncRoute = [
  {
    path: '/home',
    component: Layout,
    redirect: '/home/index',
    name: 'Home',
    meta: {
      title: '首页',
      icon: 'home',
      permission: "",
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/home/index'),
        name: 'HomeIndex',
        meta: {
          title: '首页',
          icon: 'home',
          permission: "",
        }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/order/index',
    name: 'order',
    meta: {
      title: '开单',
      icon: 'order',
      permission:'mobile:sale',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/order/index'),
        name: 'OrderIndex',
        meta: {
          title: '开单',
          icon: 'order',
          permission:'mobile:sale',
        }
      },{
        path: 'detail',
        component: () => import('@/views/order/detail'),
        name: 'OrderDetail',
        meta: {
          title: '开单-详情',
          icon: 'order',
          permission:'mobile:sale',
        }
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    redirect: '/card/index',
    name: 'Card',
    meta: {
      title: '开卡',
      icon: 'card',
      permission:'mobile:card',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/card/index'),
        name: 'CardIndex',
        meta: {
          title: '开卡',
          icon: 'order',
          permission:'mobile:card',
        }
      },{
        path: 'detail',
        component: () => import('@/views/card/detail'),
        name: 'detail',
        meta: {
          title: '开卡-详情',
          icon: 'order',
          permission:'mobile:card',
        }
      }
    ]
  },
  {
    path: '/commission',
    component: Layout,
    redirect: '/commission/index',
    name: 'Commission',
    meta: {
      title: '提成',
      icon: 'commission',
      permission:'mobile:review',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/commission/index'),
        name: 'CommissionIndex',
        meta: {
          title: '提成',
          icon: 'commission',
          permission:'mobile:review',
        }
      }
    ]
  },
  {
    path: '/report',
    component: Layout,
    redirect: '/report/index',
    name: 'Report',
    meta: {
      title: '报表',
      icon: 'Report',
      permission:'mobile:review_report',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/report/index'),
        name: 'ReportIndex',
        meta: {
          title: '报表',
          icon: 'Report',
          permission:'mobile:review_report',
        }
      },
      {
        path: 'commission',
        component: () => import('@/views/report/commission'),
        name: 'ReportCommission',
        meta: {
          title: '业绩提成报表',
          icon: 'Report',
          permission:'mobile:review_report',
        }
      },
      {
        path: 'commissionArchive',
        component: () => import('@/views/report/commissionArchive'),
        name: 'ReportCommissionArchive',
        meta: {
          title: '业绩提成报表新',
          icon: 'Report',
          permission:'mobile:review_report',
        }
      },
      {
        path: 'commissionCache',
        component: () => import('@/views/report/commissionCache'),
        name: 'ReportCommissionCache',
        meta: {
          title: '业绩提成报表新2',
          icon: 'Report',
          permission:'mobile:review_report',
        }
      },
      {
        path: 'saleSummary',
        component: () => import('@/views/report/saleSummary'),
        name: 'ReportSaleSummary',
        meta: {
          title: '业绩汇总报表',
          icon: 'Report',
          permission:'mobile:review_report',
        }
      },
      {
        path: 'saleSummaryArchive',
        component: () => import('@/views/report/saleSummaryArchive'),
        name: 'ReportSaleSummaryArchive',
        meta: {
          title: '业绩汇总报表',
          icon: 'Report',
          permission:'mobile:review_report',
        }
      },
      {
        path: 'saleSummaryCache',
        component: () => import('@/views/report/saleSummaryCache'),
        name: 'ReportSaleSummaryCache',
        meta: {
          title: '业绩汇总报表',
          icon: 'Report',
          permission:'mobile:review_report',
        }
      },
      {
        path: 'saleReport',
        component: () => import('@/views/report/saleReport'),
        name: 'ReportSale',
        meta: {
          title: '报表',
          icon: 'Report',
          permission:'mobile:review_report',
        }
      },
      {
        path: 'customerPerformance',
        component: () => import('@/views/report/customerPerformance'),
        name: 'ReportCustomerPerformance',
        meta: {
          title: '报表',
          icon: 'Report',
          permission:'mobile:review_report',
        }
      },
      {
        path: 'dailySaleReport',
        component: () => import('@/views/report/dailySaleReport'),
        name: 'ReportDailySaleReport',
        meta: {
          title: '报表',
          icon: 'Report',
          permission:'mobile:review_report',
        }
      },
      {
        path: 'monthSaleReport',
        component: () => import('@/views/report/monthlySaleReport'),
        name: 'ReportMonthlySaleReport',
        meta: {
          title: '报表',
          icon: 'Report',
          permission:'mobile:review_report',
        }
      }
    ]
  },
  {
    path: '/member',
    component: Layout,
    redirect: '/member/list',
    name: 'Member',
    meta: {
      title: '会员',
      icon: 'Member',
      permission:'mobile:customer',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/member-v1/index'),
        name: 'MemberIndex',
        meta: {
          title: '会员',
          icon: 'Member',
          permission:'mobile:customer',
        }
      }
    ]
  },
  {
    path: '/marketing',
    component: Layout,
    redirect: '/marketing/index',
    name: 'Marketing',
    meta: {
      title: '营销',
      icon: 'marketing',
      permission: 'mobile:marketing',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/marketing/index'),
        name: 'MarketingIndex',
        meta: {
          title: '营销',
          icon: 'marketing',
          permission: 'mobile:marketing',
        }
      },
      {
        path: 'campaign',
        component: () => import('@/views/marketing/campaign/index'),
        name: 'MarketingCampaign',
        meta: {
          title: '营销',
          icon: 'marketing',
          permission: 'mobile:marketing',
        }
      },
      {
        path: 'campaign/detail',
        component: () => import('@/views/marketing/campaign/detail'),
        name: 'MarketingCampaignDetail',
        meta: {
          title: '活动详情',
          icon: 'marketing',
          permission: 'mobile:marketing',
        }
      },
      {
        path: 'usercoupon',
        component: () => import('@/views/marketing/usercoupon/index'),
        name: 'MarketingUserCoupon',
        meta: {
          title: '用户券记录',
          icon: 'marketing',
          permission: 'mobile:marketing',
        }
      },
      {
        path: 'redeem',
        component: () => import('@/views/marketing/redeem/index'),
        name: 'MarketingRedeem',
        meta: {
          title: '卡券核销',
          icon: 'marketing',
          permission: 'mobile:marketing',
        }
      },
      {
        path: 'share',
        component: () => import('@/views/marketing/share/index'),
        name: 'MarketingShare',
        meta: {
          title: '分享记录',
          icon: 'marketing',
          permission: 'mobile:marketing',
        }
      }
    ]
  },
  {
    path: '/member2',
    component: Layout,
    redirect: '/member2/list',
    name: 'Member2',
    meta: {
      title: '会员',
      icon: 'Member2',
      permission:'mobile:customer',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/member-v2/index'),
        name: 'Member2Index',
        meta: {
          title: '会员',
          icon: 'Member',
          permission:'mobile:customer',
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [...routes,...asyncRoute]
})

export default router
